import api from "@/services/api";

export const authService = {
  me: () => api.get("/auth/me").then((r) => r.data.data),
  login: (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data.data),
  register: (payload) => api.post("/auth/register-company", payload).then((r) => r.data.data),
  logout: () => api.post("/auth/logout").then((r) => r.data.data),
  verifyEmail: (token) => api.post("/auth/verify-email", { token }).then((r) => r.data.data),
  resendVerification: () => api.post("/auth/resend-verification").then((r) => r.data.data),
  forgotPassword: (email) => api.post("/auth/forgot-password", { email }).then((r) => r.data.data),
  resetPassword: (token, password) => api.post("/auth/reset-password", { token, password }).then((r) => r.data.data),
};
